import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Toaster } from 'sonner';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
    <Toaster
      position="top-right"
      theme="dark"
      offset={16}
      toastOptions={{
        duration: 3500,
        style: {
          background: '#1E1D1B',
          border: '1px solid #32302D',
          color: '#ECEBE7',
          fontFamily: 'Manrope, sans-serif',
          borderRadius: '0.75rem',
          boxShadow: '0 4px 24px rgba(0, 0, 0, 0.6)',
        },
        classNames: {
          success: '!text-emerald-300',
          error: '!text-rose-300',
        },
      }}
    />
  </React.StrictMode>
);
